//
//  network/ghaCsv/api.ts
//
//  isana.net,inc. Proprietary and Confidential
//
//  GHA CSV作成API（/gha-csv/*）のクライアント。
//  Fitbit版CSV（/csv/:category, /csv-list, /csv-download）とは
//  保存領域・エンドポイントが完全分離されている。
//
import axios from "axios";
import { API_URL, MOCK_USED } from "../../utils/env";
import { logApiError } from "../../utils/logError";
import { CsvDownload } from "../type";

type ApiResult<T> = {
  data: T;
  status: number;
};

// パス切替（mock/実API）・GET・ステータス判定・エラーハンドリングの共通処理
const ghaGet = async (
  path: string,
  params: Record<string, unknown>
): Promise<ApiResult<any>> => {
  const url = MOCK_USED ? `/mock${path}` : `${API_URL}${path}`;
  return axios
    .get(url, { params })
    .then((res) => {
      if (res.status >= 200 && res.status < 300) {
        return { data: res.data, status: res.status };
      }
      return { data: undefined, status: res.status };
    })
    .catch((error) => {
      logApiError(error);
      if (error.response) {
        return { data: error.response.data, status: error.response.status };
      }
      return { data: undefined, status: 500 };
    });
};

export const getGhaExportedDailyCsv = async (
  startDate: string,
  endDate: string,
  summaryItemIds: string
) => ghaGet("/gha-csv/summary", { startDate, endDate, summaryItemIds });

export const getGhaExportedIntradayCsv = async (
  startDate: string,
  endDate: string,
  intradayItemId: string
) =>
  ghaGet("/gha-csv/intraday", {
    startDate,
    endDate,
    intradayItemIds: intradayItemId,
  });

export const getGhaCsvDownloadList = async (
  page: number,
  limit: number = 30
): Promise<
  ApiResult<
    { files: CsvDownload[]; total: number; isNext: boolean } | undefined
  >
> => {
  const res = await ghaGet("/gha-csv/list", { page, limit });
  if (res.status >= 200 && res.status < 300 && res.data) {
    return {
      data: {
        files: res.data.files,
        total: res.data.total,
        isNext: res.data.isNext,
      },
      status: res.status,
    };
  }
  return { data: undefined, status: res.status };
};

export const downloadGhaCsv = async (fileName: string) =>
  ghaGet("/gha-csv/download", { fileName });
